import HTTP from "../../http";

const CART_ENDPOINT = "/carts";
const CART_CREATE_ENDPOINT = "/";

export async function createCart(cart) {
  return await HTTP.post(
    CART_ENDPOINT + CART_CREATE_ENDPOINT,
    { cart },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
